import type { ListBuilderList } from '../../../types';

/**
 * Adverse Action list (PD-14745, was "Bad Standing") — licenses matched to a
 * registry record under a board action: Suspended / Revoked / Surrendered /
 * Denied / Probation (is_adverse in lm_status_canonical). A confirmed match to
 * a disciplined license is a compliance risk that warrants review/watch.
 *
 * This is intentionally NARROWER + more meaningful than the old "Bad Standing"
 * list: administratively-lapsed statuses (Cancelled/Expired) are NOT board
 * actions — they surface as "not covered" via the status / Expired filters, not
 * here. The list id stays `default-licenses-bad-standing` so the dashboard KPI
 * click-through keeps resolving.
 *
 * Backed by the locked `licenseRegistryStanding: adverse` filter, which reads
 * the locally-mirrored `client_license.registry_status` column (kept fresh on
 * confirm and by the nightly registry-value re-apply) — tenant-local per
 * PD-13891, and the same predicate (shared ADVERSE_STATUSES) as the dashboard's
 * Adverse Action KPI so the click-through count matches the card.
 *
 * Default sort is the `recent-sale-desc` tableSort: clients with the most
 * recent sales activity first — an actively-buying client holding a disciplined
 * license is the biggest compliance risk (Chris, 2026-07-08).
 */
export const badStandingList: ListBuilderList = {
	id: 'default-licenses-bad-standing',
	cacheTTL: 300000,
	name: 'Adverse Action',
	type: 'default',
	active: true,
	sortOrder: 5,
	filterRules: {
		licenseRegistryStanding: {
			defaultValue: [
				{
					id: 'adverse',
					label: 'Any Adverse Action',
				},
			],
			locked: true,
			hidden: true,
		},
	},
	defaultSortId: 'recent-sale-desc',
	inheritsFrom: 'default-licenses-all',
};
